/** British English display for eRIX colour names (legacy American spellings in parquet). */

function preserveCase(match: string, replacement: string): string {
    if (match.toUpperCase() === match) return replacement.toUpperCase();
    if (match[0] === match[0].toUpperCase()) {
        return replacement.charAt(0).toUpperCase() + replacement.slice(1);
    }
    return replacement;
}

export function normalizeColourSpelling(text: string): string {
    let result = text;
    for (const [pattern, repl] of [
        [/colors/gi, "colours"],
        [/color/gi, "colour"],
        [/grays/gi, "greys"],
        [/gray/gi, "grey"],
    ] as const) {
        result = result.replace(pattern, (m) => preserveCase(m, repl));
    }
    return result;
}

/** Normalize comma- or pipe-separated colour filter values for display. */
export function formatColourFilterValue(value: string, separator = ","): string {
    return value
        .split(separator)
        .map((part) => {
            const trimmed = part.trim();
            if (!trimmed) return trimmed;
            if (trimmed.toLowerCase() === "mixed") return "Mixed";
            return normalizeColourSpelling(trimmed);
        })
        .join(separator === "|" ? " | " : ", ");
}

export function colourMatchKey(value: string): string {
    return normalizeColourSpelling(value).toLowerCase();
}
